import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import React from 'react';
export var TenantList = function (_a) {
    var profile = _a.profile;
    return (_jsx(List, { children: profile.tenants.map(function (tenant) { return (_jsxs(ListItem, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, { src: tenant.image }) }), _jsx(ListItemText, { primary: tenant.name })] }, tenant.id)); }) }));
};
